import { render, staticRenderFns } from "./HomeToC.vue?vue&type=template&id=db52b97a&scoped=true&"
import script from "./HomeToC.vue?vue&type=script&lang=js&"
export * from "./HomeToC.vue?vue&type=script&lang=js&"
import style0 from "./HomeToC.vue?vue&type=style&index=0&id=db52b97a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db52b97a",
  null
  
)

export default component.exports